import isBoolean from "lodash/isBoolean";
import isDate from "lodash/isDate";
import isNumber from "lodash/isNumber";
import isString from "lodash/isString";
import pushToDataLayerGTM from "google-tag-manager/gtm.service";
import gtmConfig from "google-tag-manager/gtm.config";

export const NAMESPACE = "emun.servicebus";
export const push = pushToDataLayerGTM;

export const isScalar = (v) =>
  [isBoolean, isNumber, isString, isDate].some((fx) => fx(v));

export const isExcludedKey = (k) => k[0] === "$" || /(password|card)/gi.test(k);

export const scrub = (
  data = {},
  filter = (k, v) => !isExcludedKey(k),
  level = 0
) => {
  if (!gtmConfig.isDebug) {
    return data;
  }
  const result = {};
  for (const [key, value] of Object.entries(data || {})) {
    if (value && Array.isArray(value)) {
      result[key + ".level"] = level;
      if (level < 5) {
        result[key] = value.map((v) =>
          isScalar(v) ? v : scrub(v, filter, level + 1)
        );
      } else {
        result[key + ".length"] = value.length;
      }
    }
    if (filter(key, value, level)) {
      result[key] = value;
    }
  }
  return result;
};

export const reducer = (dl, call) => {
  dl.push(
    { event: `CLEAR!${NAMESPACE}`, [NAMESPACE]: 0 },
    {
      event: NAMESPACE,
      [NAMESPACE]: gtmConfig.isDebug ? scrub(call) : { ...call },
    }
  );
  return dl;
};

export default function gtm(...events) {
  push(...events.reduce(reducer, []));
}
